export default __webpack_public_path__ + "static/media/Bhopal.e4d5373c.jpg";